import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { StorageService } from './storage.service';
import { throwError } from 'rxjs';


const getAllDocumentos = 'biblioteca/archivos';
const existPGC2023 = 'planGestionConvivencia/existe/2023/';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 

const httpOptionsFileExcel = {

  headers: new HttpHeaders({    
     'responseType': 'arraybuffer',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})
export class BibliotecaService {
  

  constructor(private http:HttpClient,private storageService: StorageService) { }

  API_GET_getall() {
    return this.http.get(environment.apiEndpoint + getAllDocumentos , httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_GET_existPGC2023(idJardinPeriodo :number) {
    return this.http.get(environment.apiEndpoint  + existPGC2023 + idJardinPeriodo , httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    return throwError(errorMessage);
  }

}
